document.addEventListener('DOMContentLoaded', function () {
  const categories = ['Silver Charms', 'Gold Charms', 'Beads', 'Rhinestones' , 'Buttons']; // match your metafield values exactly
  const collectionUrl = window.location.pathname;

  // Only run on Secret Lab collection page
  if (!collectionUrl.includes('/collections/secret-lab')) return;

  // Build pill container
  const pillContainer = document.createElement('div');
  pillContainer.className = 'lab-filter-pills';

  // Get current active filter from URL
  const urlParams = new URLSearchParams(window.location.search);
  const activeFilter = urlParams.get('filter.p.m.custom.lab_category');

  categories.forEach(cat => {
    const pill = document.createElement('button');
    pill.className = 'lab-filter-pill' + (activeFilter === cat ? ' active' : '');
    pill.textContent = cat;

    pill.addEventListener('click', function () {
      const params = new URLSearchParams(window.location.search);
      if (activeFilter === cat) {
        // Toggle off
        params.delete('filter.p.m.custom.lab_category');
      } else {
        params.set('filter.p.m.custom.lab_category', cat);
      }
      window.location.search = params.toString();
    });

    pillContainer.appendChild(pill);
  });

  // Insert pills above the product grid — adjust selector to match Savor's grid wrapper
  const gridWrapper = document.querySelector('.collection__main, .facets-container, .product-grid-container');
  if (gridWrapper) {
    gridWrapper.insertBefore(pillContainer, gridWrapper.firstChild);
  }
});
